import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter } from "react-router-dom";


import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";

import { msalConfig } from "./authConfig";
export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();

console.log(accounts);

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    console.log(account, 'account')

    msalInstance.setActiveAccount(account);
  }
});

msalInstance.initialize().then(() => {
  msalInstance
    .handleRedirectPromise()

    .then((authResult) => {
      const account = msalInstance.getActiveAccount();

      console.log(account);

      if (!account) {
        msalInstance.loginRedirect();
      }
    })

    .catch((err) => {
      console.log(err);
    });
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <AuthProvider> */}

      <App pca={msalInstance} />

      {/* </AuthProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

